module.exports = __webpack_public_path__ + "img/geofisica_3-4_1536.76df0f46.jpg";